/**
 * Shows the fixed add-to-bag bar (bottom: 0) when the user scrolls down past
 * the main product form actions. Hides it when the form is back in view.
 */
function initAddToBagBar() {
  const bar = document.querySelector(".product-add-to-bag-bar");
  const mainProduct = document.querySelector(".main-product");
  if (!bar || !mainProduct) return;

  const formActions = mainProduct.querySelector(".product-form__actions");
  if (!formActions) return;

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        // When form actions have scrolled up out of view (user scrolled down), show the bar
        const isPastForm = entry.boundingClientRect.top < 0;
        bar.classList.toggle(
          "product-add-to-bag-bar--visible",
          !entry.isIntersecting && isPastForm,
        );
      });
    },
    {
      root: null,
      rootMargin: "0px",
      threshold: 0,
    },
  );

  observer.observe(formActions);
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", initAddToBagBar);
} else {
  initAddToBagBar();
}
